<template>
  <Popup :ref="(el) => popup = el"
         class="popup__lg"
         :title="$t('requisites.templates.title')"
         @onClose="hide"
  >
    <LoaderContent ref="loader" class="">
      <div class="mb-2 text-muted small">{{ $t('requisites.templates.hint') }}</div>
      <div style="overflow: auto">
        <table class="table table-striped" style="position: relative">
          <thead>
          <tr>
            <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('requisites.templates.name') }}</span></th>
            <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.currency') }}</span></th>
            <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.payment_option') }}</span></th>
            <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('requisites.templates.field.method') }}</span></th>
            <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.req_group') }}</span></th>
            <th class="text-start p-sm"><span class="text-capitalize-first">{{ $t('labels.device') }}</span></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loaded && templates.length === 0">
            <td colspan="7" class="text-center p-sm text-muted">{{ $t('requisites.templates.empty') }}</td>
          </tr>
          <tr v-for="item in templates" :key="item.id">
            <td class="p-sm">{{ item.name }}</td>
            <td class="p-sm">{{ item.currency ?? '-' }}</td>
            <td class="p-sm">{{ item.paymentOption ? helper.trans('payment_options.' + item.paymentOption) : '-' }}</td>
            <td class="p-sm">{{ item.method ? helper.trans('pay_methods.' + item.method) : '-' }}</td>
            <td class="p-sm">{{ groupName(item.groupId) }}</td>
            <td class="p-sm">{{ deviceName(item.deviceId) }}</td>
            <td class="text-end p-sm">
              <div class="d-flex justify-content-end align-items-center gap-sm">
                <button type="button" @click="$emit('edit', item)" class="btn detail__btn detail__redact" :title="$t('button.edit')">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.43302 17.9172L2.69502 14.7622C2.89605 14.2592 3.19714 13.8023 3.58002 13.4192L13.9898 3.01046L16.9903 6.01046L6.58102 16.4192C6.19799 16.8025 5.74108 17.1039 5.23802 17.3052L2.08302 18.5672C1.99216 18.6036 1.89262 18.6125 1.79674 18.5928C1.70087 18.5731 1.61287 18.5258 1.54366 18.4566C1.47446 18.3874 1.42708 18.2994 1.40742 18.2035C1.38775 18.1076 1.39665 18.0081 1.43302 17.9172Z" fill="#F7F9FC"></path><path d="M18.1213 4.0012C18.1213 4.56381 17.8978 5.10338 17.5 5.5012L14.5 2.5012C14.8978 2.10338 15.4374 1.87988 16 1.87988C16.5626 1.87988 17.1022 2.10338 17.5 2.5012C17.8978 2.89903 18.1213 3.43859 18.1213 4.0012Z" fill="#F7F9FC"></path></svg>
                </button>
                <button type="button" @click="remove(item)" class="btn detail__btn detail__remove" :title="$t('button.delete')">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 3C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V5C1 5.26522 1.10536 5.51957 1.29289 5.70711C1.48043 5.89464 1.73478 6 2 6H18C18.2652 6 18.5196 5.89464 18.7071 5.70711C18.8946 5.51957 19 5.26522 19 5V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H2Z" fill="#F7F9FC"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2 7.5H18L17.189 15.21C17.1371 15.7015 16.905 16.1564 16.5376 16.487C16.1701 16.8175 15.6933 17.0003 15.199 17H4.802C4.30774 17.0003 3.8309 16.8175 3.46343 16.487C3.09596 16.1564 2.8639 15.7015 2.812 15.21L2 7.5ZM7.22 9.22C7.36063 9.07955 7.55125 9.00066 7.75 9.00066C7.94875 9.00066 8.13937 9.07955 8.28 9.22L10 10.94L11.72 9.22C11.7887 9.14631 11.8715 9.08721 11.9635 9.04622C12.0555 9.00523 12.1548 8.98318 12.2555 8.98141C12.3562 8.97963 12.4562 8.99816 12.5496 9.03588C12.643 9.0736 12.7278 9.12974 12.799 9.20096C12.8703 9.27218 12.9264 9.35701 12.9641 9.4504C13.0018 9.54379 13.0204 9.64382 13.0186 9.74452C13.0168 9.84522 12.9948 9.94454 12.9538 10.0365C12.9128 10.1285 12.8537 10.2113 12.78 10.28L11.06 12L12.78 13.72C12.8537 13.7887 12.9128 13.8715 12.9538 13.9635C12.9948 14.0555 13.0168 14.1548 13.0186 14.2555C13.0204 14.3562 13.0018 14.4562 12.9641 14.5496C12.9264 14.643 12.8703 14.7278 12.799 14.799C12.7278 14.8703 12.643 14.9264 12.5496 14.9641C12.4562 15.0018 12.3562 15.0204 12.2555 15.0186C12.1548 15.0168 12.0555 14.9948 11.9635 14.9538C11.8715 14.9128 11.7887 14.8537 11.72 14.78L10 13.06L8.28 14.78C8.13783 14.9125 7.94978 14.9846 7.75548 14.9812C7.56118 14.9777 7.37579 14.899 7.23838 14.7616C7.10097 14.6242 7.02225 14.4388 7.01883 14.2445C7.0154 14.0502 7.08752 13.8622 7.22 13.72L8.94 12L7.22 10.28C7.07955 10.1394 7.00066 9.94875 7.00066 9.75C7.00066 9.55125 7.07955 9.36063 7.22 9.22Z" fill="#F7F9FC"></path></svg>
                </button>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="7" class="text-center">
              <button type="button" @click="$emit('create')" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100">
                <span class="text-capitalize-first">{{ $t('requisites.templates.create') }}</span>
              </button>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </LoaderContent>
  </Popup>
  <ConfirmPopup ref="confirmPopup"></ConfirmPopup>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import {useStore} from 'vuex';
import {useNotification} from "@kyvg/vue3-notification";
import Popup from "@/apps/public/components/Popup.vue";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import ConfirmPopup from "@/apps/public/components/ConfirmPopup.vue";
import {$t, helper} from "@/service/CommonHelper";
import {api} from "@/service/APIClient";
import RequisiteTemplateDTO from "@/models/RequisiteTemplateDTO";

export default defineComponent({
  emits: ['create', 'edit', 'deleted'],
  methods: {$t},
  components: {ConfirmPopup, LoaderContent, Popup},
  setup(props, {emit}) {
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
    const confirmPopup = ref<InstanceType<typeof ConfirmPopup> | null>(null)
    const store = useStore()
    const notification = useNotification()
    const state = reactive({
      templates: [] as RequisiteTemplateDTO[],
      loaded: false,
    });

    const load = async () => {
      loader.value?.show()
      try {
        state.templates = await api.requisiteTemplatesAll()
        state.loaded = true
      } finally {
        loader.value?.hide()
      }
    }

    const groupName = (id: number | null): string => {
      if (id === null) {
        return '-'
      }

      return store.getters['reqGroups/get'](id)?.name ?? `#${id}`
    }

    const deviceName = (id: string | null): string => {
      if (id === null) {
        return '-'
      }

      return store.getters['devices/get'](id)?.name ?? `#${id.slice(0, 8)}`
    }

    const remove = (item: RequisiteTemplateDTO) => {
      confirmPopup.value?.show({
        title: $t('requisites.templates.delete_confirm', {name: item.name}),
        okTitle: $t('button.delete'),
        onOkClick: async () => {
          try {
            await api.requisiteTemplateDelete(item.id)
            notification.notify({title: helper.trans('requisites.templates.deleted')})
            emit('deleted', item)
          } catch (e) {
            helper.handleErrors('requisiteTemplates', e)
          }
          await load()
        }
      })
    }

    const show = () => {
      popup.value?.show()
      load()
    }

    const hide = () => {
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      popup,
      loader,
      confirmPopup,
      helper,
      groupName,
      deviceName,
      remove,
      show,
      hide,
      reload: load,
    }
  }
})
</script>
